import React from 'react';
import PropTypes from 'prop-types';

import { GeoJsonLayer } from 'mapping/leaflet';

import { styleMethods } from 'dataviz/config/map';

/** A map layer for depicting field boundaries and a filled area. */
const FieldLayer = ({boundaryGeoJson, color, map}) =>
  (<GeoJsonLayer
    geoJson={boundaryGeoJson}
    layerStyle={styleMethods.filled(color)}
    map={map}
  />);

FieldLayer.propTypes = {
  boundaryGeoJson: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
  map: PropTypes.object // Inserted by mapping/leaflet.
};
export default FieldLayer;